// extracted by mini-css-extract-plugin
export default {"labcPanel":"labc-panel_labcPanel__omrGD"};